import {clickOutside} from '@malt/dom';

Hop.defineModule('dropdown-navigation', (root, params = {}) => {
    const $navigationDropdownCTA = root.querySelector('[data-trigger-dropdown]');
    const $navigationDropdown = root.querySelector('[data-navigation-dropdown]');
    const $activeCtaClass = params.activeCtaClass || 'active';
    const $visibleDropdownCustomClass = 'visible-dropdown';
    const alwaysActive = $navigationDropdownCTA.classList.contains('active');

    function init() {
        checkSelectors();
        listenToEvents();

        if (params.hoverToggle) {
            appendGapFillerForHover();
        }
    }

    function checkSelectors() {
        if (!$navigationDropdownCTA || !$navigationDropdown) {
            throw Error('Missing [data-trigger-dropdown] or [data-navigation-dropdown] attribute for your module');
        }
    }

    function listenToEvents() {
        if (params.hoverToggle) {
            $navigationDropdownCTA.addEventListener('mouseover', showDropdown);
            root.addEventListener('mouseleave', hideDropdown);
        } else {
            $navigationDropdownCTA.addEventListener('click', toggleDropdown);
            window.addEventListener('click', handleClickOutside);
        }
    }

    function appendGapFillerForHover() {
        const $gapFiller = document.createElement('div');
        $gapFiller.classList.add('m-dropdown_menu__gap-filler');
        root.appendChild($gapFiller);
    }

    function handleClickOutside(e) {
        if (clickOutside(e, root)) {
            hideDropdown();
        }
    }

    function toggleDropdown() {
        $navigationDropdown.classList.toggle($visibleDropdownCustomClass);

        if (!alwaysActive) {
            $navigationDropdownCTA.classList.toggle($activeCtaClass);
        }
    }

    function showDropdown() {
        $navigationDropdown.classList.add($visibleDropdownCustomClass);

        if (!alwaysActive) {
            $navigationDropdownCTA.classList.add($activeCtaClass);
        }
    }

    function hideDropdown() {
        $navigationDropdown.classList.remove($visibleDropdownCustomClass);

        if (!alwaysActive) {
            $navigationDropdownCTA.classList.remove($activeCtaClass);
        }
    }

    init();

    return function destroy() {
        if (params.hoverToggle) {
            $navigationDropdownCTA.removeEventListener('mouseover', showDropdown);
            root.removeEventListener('mouseleave', hideDropdown);
        } else {
            $navigationDropdownCTA.removeEventListener('click', toggleDropdown);
            window.removeEventListener('click', handleClickOutside);
        }
    };
});
